import { Modal } from '@mui/material';
import { AppButton } from '../AppButton/AppButton';
import { COLORS } from '../../../utils/colors';
import { X, Eye } from 'react-feather';
import { Link } from 'phosphor-react';
import { PreliminaryNoticeApiResponse } from '@dill/dill-shared/dist/src';
import moment from 'moment';

export const AppTrackPreliminaryNoticeModal = ({
  open,
  handleClose,
  preliminaryNotice,
  onPreviewAttachment,
}: {
  open: boolean;
  handleClose?: () => void;
  preliminaryNotice: PreliminaryNoticeApiResponse | null;
  onPreviewAttachment: (url: string, fileType?: string) => void;
}) => {
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div className="flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg  flex-col min-h-8 w-[640px]">
        <h2 className="text-lg font-semibold mx-4 my-3">Track Notice</h2>
        <X
          className="absolute right-4 top-4 cursor-pointer"
          color={COLORS.GREY_500}
          onClick={handleClose}
        />
        <div style={{ height: '0.01em' }} className="h-0.5 w-full bg-slate-400"></div>
        <div className="mx-4 mt-3 mb-2 overflow-y-auto max-h-[calc(100vh-240px)]">
          <div className="flex justify-between items-center mb-3">
            <div className="text-[14px] font-bold w-[160px]">Submitted</div>
            <div className="text-[14px] font-medium w-[50px]">
              {preliminaryNotice?.createdAt
                ? moment(preliminaryNotice?.createdAt).format('MM/DD/YYYY')
                : ''}
            </div>
            <div className="w-[130px]"></div>
          </div>
          <div className="mb-3">
            <div className="text-[14px] font-bold">Mailed</div>
            {preliminaryNotice?.contractorsStatus &&
              preliminaryNotice?.contractorsStatus.length > 0 && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">GC</div>
                  {preliminaryNotice?.contractorsStatus.map((contractor, index) => {
                    const contractorIsNeeded =
                      contractor?.isNeeded === undefined ? true : contractor?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`gc-status-mailed-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {contractor?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {contractor?.mailedDate
                            ? moment(contractor?.mailedDate).format('MM/DD/YYYY')
                            : contractorIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px]">
                          {contractor?.trackLink && (
                            <a
                              className="cursor-pointer"
                              href={`${contractor?.trackLink}`}
                              target="_blank"
                              rel="noreferrer">
                              <Link size={18} />
                            </a>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {preliminaryNotice?.ownersStatus && preliminaryNotice?.ownersStatus.length > 0 && (
              <div>
                <div className="text-[14px] font-bold ml-[10px] w-[150px]">Owner</div>
                {preliminaryNotice?.ownersStatus.map((owner, index) => {
                  const ownerIsNeeded = owner?.isNeeded === undefined ? true : owner?.isNeeded;
                  return (
                    <div
                      className="flex justify-between items-center mb-1"
                      key={`owner-status-mailed-${index}`}>
                      <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                        {owner?.name ?? ''}
                      </div>
                      <div className="text-[14px] font-medium w-[50px]">
                        {owner?.mailedDate
                          ? moment(owner?.mailedDate).format('MM/DD/YYYY')
                          : ownerIsNeeded
                          ? 'Pending'
                          : 'N/A'}
                      </div>
                      <div className="w-[130px]">
                        {owner?.trackLink && (
                          <a
                            className="cursor-pointer"
                            href={`${owner?.trackLink}`}
                            target="_blank"
                            rel="noreferrer">
                            <Link size={18} />
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {preliminaryNotice?.lendersStatus && preliminaryNotice?.lendersStatus.length > 0 && (
              <div>
                <div className="text-[14px] font-bold ml-[10px] w-[150px]">Lender</div>
                {preliminaryNotice?.lendersStatus.map((lender, index) => {
                  const lenderIsNeeded = lender?.isNeeded === undefined ? true : lender?.isNeeded;
                  return (
                    <div
                      className="flex justify-between items-center mb-1"
                      key={`lender-status-mailed-${index}`}>
                      <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                        {lender?.name ?? ''}
                      </div>
                      <div className="text-[14px] font-medium w-[50px]">
                        {lender?.mailedDate
                          ? moment(lender?.mailedDate).format('MM/DD/YYYY')
                          : lenderIsNeeded
                          ? 'Pending'
                          : 'N/A'}
                      </div>
                      <div className="w-[130px]">
                        {lender?.trackLink && (
                          <a
                            className="cursor-pointer"
                            href={`${lender?.trackLink}`}
                            target="_blank"
                            rel="noreferrer">
                            <Link size={18} />
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {preliminaryNotice?.customersStatus &&
              preliminaryNotice?.customersStatus?.length > 0 && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">Customer</div>
                  {preliminaryNotice?.customersStatus.map((customer, index) => {
                    const customerIsNeeded =
                      customer?.isNeeded === undefined ? true : customer?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`customer-status-mailed-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {customer?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {customer?.mailedDate
                            ? moment(customer?.mailedDate).format('MM/DD/YYYY')
                            : customerIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px]">
                          {customer?.trackLink && (
                            <a
                              className="cursor-pointer"
                              href={`${customer?.trackLink}`}
                              target="_blank"
                              rel="noreferrer">
                              <Link size={18} />
                            </a>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {preliminaryNotice?.suretiesStatus &&
              preliminaryNotice?.suretiesStatus?.length > 0 &&
              preliminaryNotice?.job?.isJobBonded && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">Surety</div>
                  {preliminaryNotice?.suretiesStatus.map((surety, index) => {
                    const suretyIsNeeded = surety?.isNeeded === undefined ? true : surety?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`surety-status-mailed-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {surety?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {surety?.mailedDate
                            ? moment(surety?.mailedDate).format('MM/DD/YYYY')
                            : suretyIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px]">
                          {surety?.trackLink && (
                            <a
                              className="cursor-pointer"
                              href={`${surety?.trackLink}`}
                              target="_blank"
                              rel="noreferrer">
                              <Link size={18} />
                            </a>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
          <div>
            <div className="text-[14px] font-bold">Delivered</div>
            {preliminaryNotice?.contractorsStatus &&
              preliminaryNotice?.contractorsStatus?.length > 0 && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">GC</div>
                  {preliminaryNotice?.contractorsStatus.map((contractor, index) => {
                    const contractorIsNeeded =
                      contractor?.isNeeded === undefined ? true : contractor?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`gc-status-delivered-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {contractor?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {contractor?.status
                            ? contractor?.status
                            : contractor?.deliveredDate
                            ? moment(contractor?.deliveredDate).format('MM/DD/YYYY')
                            : contractorIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px] flex gap-1">
                          {contractor?.attachments &&
                            contractor?.attachments.length > 0 &&
                            contractor.attachments.map((attachment) => (
                              <AppButton
                                type="TERTIARY"
                                buttonStyles={{
                                  padding: '4px',
                                  height: '30px',
                                  width: '30px',
                                }}
                                icon={<Eye color={COLORS.GREY_500} size={18} />}
                                onClick={() => {
                                  onPreviewAttachment(attachment?.url ?? '', attachment?.fileType);
                                }}
                              />
                            ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {preliminaryNotice?.ownersStatus && preliminaryNotice?.ownersStatus?.length > 0 && (
              <div>
                <div className="text-[14px] font-bold ml-[10px] w-[150px]">Owner</div>
                {preliminaryNotice?.ownersStatus.map((owner, index) => {
                  const ownerIsNeeded = owner?.isNeeded === undefined ? true : owner?.isNeeded;
                  return (
                    <div
                      className="flex justify-between items-center mb-1"
                      key={`owner-status-delivered-${index}`}>
                      <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                        {owner?.name ?? ''}
                      </div>
                      <div className="text-[14px] font-medium w-[50px]">
                        {owner?.status
                          ? owner?.status
                          : owner?.deliveredDate
                          ? moment(owner?.deliveredDate).format('MM/DD/YYYY')
                          : ownerIsNeeded
                          ? 'Pending'
                          : 'N/A'}
                      </div>
                      <div className="w-[130px] flex gap-1">
                        {owner?.attachments &&
                          owner?.attachments.length > 0 &&
                          owner.attachments.map((attachment) => (
                            <AppButton
                              type="TERTIARY"
                              buttonStyles={{
                                padding: '4px',
                                height: '30px',
                                width: '30px',
                              }}
                              icon={<Eye color={COLORS.GREY_500} size={18} />}
                              onClick={() => {
                                onPreviewAttachment(attachment?.url ?? '', attachment?.fileType);
                              }}
                            />
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {preliminaryNotice?.lendersStatus && preliminaryNotice?.lendersStatus.length > 0 && (
              <div>
                <div className="text-[14px] font-bold ml-[10px] w-[150px]">Lender</div>
                {preliminaryNotice?.lendersStatus.map((lender, index) => {
                  const lenderIsNeeded = lender?.isNeeded === undefined ? true : lender?.isNeeded;
                  return (
                    <div
                      className="flex justify-between items-center mb-1"
                      key={`lender-status-delivered-${index}`}>
                      <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                        {lender?.name ?? ''}
                      </div>
                      <div className="text-[14px] font-medium w-[50px]">
                        {lender?.status
                          ? lender?.status
                          : lender?.deliveredDate
                          ? moment(lender?.deliveredDate).format('MM/DD/YYYY')
                          : lenderIsNeeded
                          ? 'Pending'
                          : 'N/A'}
                      </div>
                      <div className="w-[130px] flex gap-1">
                        {lender?.attachments &&
                          lender?.attachments.length > 0 &&
                          lender.attachments.map((attachment) => (
                            <AppButton
                              type="TERTIARY"
                              buttonStyles={{
                                padding: '4px',
                                height: '30px',
                                width: '30px',
                              }}
                              icon={<Eye color={COLORS.GREY_500} size={18} />}
                              onClick={() => {
                                onPreviewAttachment(attachment?.url ?? '', attachment?.fileType);
                              }}
                            />
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {preliminaryNotice?.customersStatus &&
              preliminaryNotice?.customersStatus?.length > 0 && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">Customer</div>
                  {preliminaryNotice?.customersStatus.map((customer, index) => {
                    const customerIsNeeded =
                      customer?.isNeeded === undefined ? true : customer?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`customer-status-delivered-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {customer?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {customer?.status
                            ? customer?.status
                            : customer?.deliveredDate
                            ? moment(customer?.deliveredDate).format('MM/DD/YYYY')
                            : customerIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px] flex gap-1">
                          {customer?.attachments &&
                            customer?.attachments.length > 0 &&
                            customer.attachments.map((attachment) => (
                              <AppButton
                                type="TERTIARY"
                                buttonStyles={{
                                  padding: '4px',
                                  height: '30px',
                                  width: '30px',
                                }}
                                icon={<Eye color={COLORS.GREY_500} size={18} />}
                                onClick={() => {
                                  onPreviewAttachment(attachment?.url ?? '', attachment?.fileType);
                                }}
                              />
                            ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            {preliminaryNotice?.suretiesStatus &&
              preliminaryNotice?.suretiesStatus?.length > 0 &&
              preliminaryNotice?.job?.isJobBonded && (
                <div>
                  <div className="text-[14px] font-bold ml-[10px] w-[150px]">Surety</div>
                  {preliminaryNotice?.suretiesStatus.map((surety, index) => {
                    const suretyIsNeeded = surety?.isNeeded === undefined ? true : surety?.isNeeded;
                    return (
                      <div
                        className="flex justify-between items-center mb-1"
                        key={`surety-status-delivered-${index}`}>
                        <div className="text-[14px] font-medium ml-[10px] w-[150px]">
                          {surety?.name ?? ''}
                        </div>
                        <div className="text-[14px] font-medium w-[50px]">
                          {surety?.status
                            ? surety?.status
                            : surety?.deliveredDate
                            ? moment(surety?.deliveredDate).format('MM/DD/YYYY')
                            : suretyIsNeeded
                            ? 'Pending'
                            : 'N/A'}
                        </div>
                        <div className="w-[130px] flex gap-1">
                          {surety?.attachments &&
                            surety?.attachments.length > 0 &&
                            surety.attachments.map((attachment) => (
                              <AppButton
                                type="TERTIARY"
                                buttonStyles={{
                                  padding: '4px',
                                  height: '30px',
                                  width: '30px',
                                }}
                                icon={<Eye color={COLORS.GREY_500} size={18} />}
                                onClick={() => {
                                  onPreviewAttachment(attachment?.url ?? '', attachment?.fileType);
                                }}
                              />
                            ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
          </div>
        </div>
        <div style={{ height: '0.01em' }} className="h-0.5 w-full bg-slate-400 my-4"></div>
        <div className="flex justify-end mx-3 mb-2">
          <AppButton
            text="Cancel"
            type="TERTIARY"
            onClick={handleClose}
            buttonStyles={{ marginRight: '8px' }}
          />
        </div>
      </div>
    </Modal>
  );
};
